<label class="field-toggle" [class.field-toggle--disabled]="disabled()" [attr.for]="inputId()">
  <input
    class="field-toggle__input"
    type="checkbox"
    role="switch"
    [id]="inputId()"
    [checked]="value()"
    [disabled]="disabled()"
    [attr.aria-checked]="value()"
    (change)="handleChange($event)"
  />
  <span class="field-toggle__track" aria-hidden="true">
    <span class="field-toggle__thumb"></span>
  </span>
  <span class="field-toggle__text">
    <span class="field-toggle__label">{{ label() }}</span>
    @if (description(); as d) {
      <span class="field-toggle__description">{{ d }}</span>
    }
  </span>
</label>
